import Application from "../../Application";
import RegisteredApplicantsPresenter, {
  IRegisteredApplicantsPresenter
} from "../../presenter/applicants/RegisteredApplicantsPresenter";
import { IApplicantService } from "../../service/applicant/ApplicantService";

export default class ShowRegisteredApplicantsInteractor {
  private application: Application;
  private output?: IRegisteredApplicantsPresenter;
  private applicantService: IApplicantService;

  constructor(application, applicantService) {
    this.application = application;
    this.applicantService = applicantService;
  }

  async getInitialData() {
    const registeredApplicants =
      await this.applicantService.getRegisteredApplicants();
    const parties = await this.applicantService.getParties();

    return { registeredApplicants, parties };
  }

  execute() {
    this.output = RegisteredApplicantsPresenter({
      application: this.application,
      initialState: {
        registeredApplicants: [],
        applicantsAppointments: [],
        parties: [],
        unregisteredParties: []
      }
    });

    this.getInitialData().then((output) =>
      this.output?.loadInitialData(output.registeredApplicants, output.parties)
    );

    return this.output;
  }
}
